/* eslint-disable default-param-last */
/**
 * @description Reducer sobre as manipulações de solicitacões de  Exame
 * @author Bene Lemuel Dantas Gondim
 * @file solicitacaoExameReducer.js
 *
 * @license Copyright (c) 2020 SIGEP DIGETI ITEP/RN
 */
import types from 'utils/actionTypes'

// Estado inicial da sessão no redux
const initialState = {
  solicitacaoExame: null,
  caso: null,
  error: null,
  nomeFuncao: '',
  dados: {
    id: '',
  },
  periciandos: null,
  locais: null,
}

const solicitacaoExameReducer = (state = initialState, action) => {
  switch (action.type) {
    case types.FETCH_SOLICITACAO_EXAME: {
      return {
        ...state,
        solicitacaoExame: action.solicitacaoExame,
      }
    }

    default: {
      return state
    }
  }
}

export default solicitacaoExameReducer
